import Playoffs from "./Playoffs";
import SwissSystem from "./SwissSystem";
import RoundRobin from "./RoundRobin";

export const Managers:{[id:string]: any} = {
    SwissSystem,
    Playoffs,
    RoundRobin
};
